import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/i18n-setup';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ColorModeProvider } from './theme/ColorModeProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ColorModeProvider>
      <App />
    </ColorModeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
